'use client'

import React, { HTMLAttributes } from 'react';
import Link from 'next/link';

import styles from './styles.module.css'
import { usePathname } from 'next/navigation';

interface IUnderlinedLinkProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  href: string;
}

export const UnderlinedLink: React.FC<IUnderlinedLinkProps> = ({
  title,
  href,
  className,
}) => {
  const pathname = usePathname();
  return (
    <Link
      className={`
        ${styles['link']} transition delay-200 flex flex-col w-fit text-gray-500 space-y-4 h-fit !leading-[1.25] px-[.2em] text-base
        hover:text-gray-900 ${href === pathname && '!text-gray-900 ' + styles['selected-link']}
        ${className}
      `}
      href={href}
    >
      <span>{title}</span>
    </Link>
  );
};
